export const IOS_STORE_URL =
  'https://apps.apple.com/al/app/autoplace-al-makina-n%C3%AB-shitje/id6753959493';

const ANDROID_BASE_URL =
  'https://play.google.com/store/apps/details?id=al.autoplace.app';

/**
 * Google Play install-referrer string. Firebase Analytics on the device decodes
 * this on first open (Play Install Referrer API) which gives exact Android
 * attribution. Formatted as UTM params so Firebase auto-populates the campaign.
 */
export function androidStoreUrl(campaign?: string | null): string {
  if (!campaign) return ANDROID_BASE_URL;
  const referrer = `utm_source=${campaign}&utm_medium=influencer&utm_campaign=${campaign}`;
  return `${ANDROID_BASE_URL}&referrer=${encodeURIComponent(referrer)}`;
}
